import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { VirtualUserPool } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("VIRTUAL_USER_POOL_MODULE");

export const moduleActions = createDataModuleActions<VirtualUserPool>(actionCreator);
export const getVirtualUserPoolTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const virtualUserPoolActions = {
  ...normalizeActions(moduleActions.data),
};
export const virtualUserPoolActionCreators = {
  ...moduleActions,
};
